import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Swal from "sweetalert2";
import CardUser from "./CardUser";

const CreateUsersForOrganizacion = ({ usuarios, setUsuarios }) => {
  const [userFormValues, setUserFormValues] = useState({
    name: "",
    lastname: "",
    email: "",
    password: "",
    phone: "",
    userType: "Asesor",
    provincia: "",
    partido: "",

  });

  const [provincias, setProvincias] = useState([]);
  const [partidos, setPartidos] = useState([]);
  const [localidades, setLocalidades] = useState([]);

  // Obtener todas las provincias
  useEffect(() => {
    const fetchProvincias = async () => {
      try {
        const response = await fetch("https://flexy.com.ar/api/map/getAllPronvinces");
        if (!response.ok) {
          throw new Error("Error al obtener las provincias");
        }
        const data = await response.json();
        setProvincias(data);
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Error al cargar las provincias",
          text: "No se pudieron obtener las provincias. Intente nuevamente más tarde.",
          confirmButtonText: "Listo",
          confirmButtonColor: "#003049",
        });
      }
    };

    fetchProvincias();
  }, []);

  // Obtener partidos según la provincia seleccionada
  const handleProvinciaChange = async (e) => {
    const selectedProvincia = e.target.value;
    setUserFormValues({
      ...userFormValues,
      provincia: selectedProvincia,
      partido: "",
      localidad: "", // Resetear partido y localidad cuando cambia la provincia
    });

    try {
      const response = await fetch(`https://flexy.com.ar/api/map/getAllPartidos`);
      if (!response.ok) {
        throw new Error("Error al obtener los partidos");
      }
      const data = await response.json();
      const partidosFiltrados = data.filter(
        (partido) => partido.ProvinciaPartidoId === selectedProvincia
      );
      setPartidos(partidosFiltrados);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al cargar los partidos",
        text: "No se pudieron obtener los partidos. Intente nuevamente más tarde.",
        confirmButtonText: "Listo",
        confirmButtonColor: "#003049",
      });
    }
  };

  // Obtener localidades según el partido seleccionado
  const handlePartidoChange = async (e) => {
    const selectedPartido = e.target.value;
    setUserFormValues({
      ...userFormValues,
      partido: selectedPartido,
      localidad: "", // Resetear localidad cuando cambia el partido
    });

    try {
      const response = await fetch(`https://flexy.com.ar/api/map/getAllCiudades`);
      if (!response.ok) {
        throw new Error("Error al obtener las localidades");
      }
      const data = await response.json();
      const localidadesFiltradas = data.filter(
        (ciudad) => ciudad.PartidoId === selectedPartido
      );
      setLocalidades(localidadesFiltradas);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al cargar las localidades",
        text: "No se pudieron obtener las localidades. Intente nuevamente más tarde.",
        confirmButtonText: "Listo",
        confirmButtonColor: "#003049",
      });
    }
  };

  const handleUserInputChange = (e) => {
    const { name, value } = e.target;
    setUserFormValues({
      ...userFormValues,
      [name]: value,
    });
  };

  const handleAddUser = () => {
    const { name, lastname, email, password, userType, provincia, partido, localidad } = userFormValues;
    if (name && lastname && email && password && userType && provincia && partido) {
      setUsuarios([...usuarios, userFormValues]);
      setUserFormValues({
        name: "",
        lastname: "",
        email: "",
        password: "",
        phone: "",
        userType: "Asesor",
        provincia: "",
        partido: "",
        localidad: "",
      });
      Swal.fire({
        icon: "success",
        title: "Usuario agregado exitosamente",
        confirmButtonText: "Listo",
        confirmButtonColor: "#003049",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Complete todos los campos del usuario",
        confirmButtonText: "Listo",
        confirmButtonColor: "#003049",
      });
    }
  };

  return (
    <UsuariosContainer>
      <ContentList>
        <Title>Usuarios de la organización</Title>
        <UserList>
          {usuarios.length < 1 ? (
            <NOFoundUsers>
              Aún no hay usuarios en la organización. <br /> Para continuar debe
              crear al menos un usuario tipo Admin.
            </NOFoundUsers>
          ) : null}
          {usuarios.map((user, index) => (
            <CardUser key={index}>
              {user.name} {user.lastname} ({user.userType}) - {user.email}
            </CardUser>
          ))}
        </UserList>
      </ContentList>
      <FormGrid>
        <InputContainer>
          <Label htmlFor="name">Nombre del usuario *</Label>
          <Input
            id="name"
            name="name"
            value={userFormValues.name}
            onChange={handleUserInputChange}
            placeholder="Ingrese nombre"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="lastname">Apellido del usuario *</Label>
          <Input
            id="lastname"
            name="lastname"
            value={userFormValues.lastname}
            onChange={handleUserInputChange}
            placeholder="Ingrese apellido"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="email">Correo electrónico *</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={userFormValues.email}
            onChange={handleUserInputChange}
            placeholder="Ingrese correo"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="password">Clave *</Label>
          <Input
            id="password"
            name="password"
            type="password"
            value={userFormValues.password}
            onChange={handleUserInputChange}
            placeholder="Ingrese clave"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="phone">Teléfono</Label>
          <Input
            id="phone"
            name="phone"
            value={userFormValues.phone}
            onChange={handleUserInputChange}
            placeholder="Ingrese teléfono"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="userType">Tipo de usuario *</Label>
          <Select
            id="userType"
            name="userType"
            value={userFormValues.userType}
            onChange={handleUserInputChange}
          >
            <option value="Admin">Administrador</option>
            <option value="Supervisor">Supervisor</option>
            <option value="Productor">Productor</option>
            <option value="Asesor comercial">Asesor comercial</option>
          </Select>
        </InputContainer>
        <InputContainer>
          <Label htmlFor="provincia">Provincia *</Label>
          <Select
            id="provincia"
            name="provincia"
            value={userFormValues.provincia}
            onChange={handleProvinciaChange}
          >
            <option value="">Seleccione una provincia</option>
            {provincias.map((provincia) => (
              <option key={provincia.id} value={provincia.id}>
                {provincia.name}
              </option>
            ))}
          </Select>
        </InputContainer>
        <InputContainer>
          <Label htmlFor="partido">Partido *</Label>
          <Select
            id="partido"
            name="partido"
            value={userFormValues.partido}
            onChange={handlePartidoChange}
            disabled={!userFormValues.provincia}
          >
            <option value="">Seleccione un partido</option>
            {partidos.map((partido) => (
              <option key={partido.id} value={partido.id}>
                {partido.name}
              </option>
            ))}
          </Select>
        </InputContainer>

        <ButtonAddUser type="button" onClick={handleAddUser}>
          Agregar Usuario
        </ButtonAddUser>
      </FormGrid>
    </UsuariosContainer>
  );
};

export default CreateUsersForOrganizacion;

// Styled components
const NOFoundUsers = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  margin: auto;
  text-align: center;
`;

const ContentList = styled.div`
  width: 45%;
  height: auto;
  gap: 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0%;
  scroll-behavior: smooth;
  border-radius: 8px;
  justify-content: flex-start;
`;

const UsuariosContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
  width: 50%;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
`;

const Input = styled.input`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  &::placeholder {
    color: #999;
  }
`;

const Select = styled.select`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #333;
`;

const ButtonAddUser = styled.button`
  padding: 12px 24px;
  background-color: #003049;
  border: none;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    background-color: #002538;
  }
`;

const UserList = styled.div`
  width: 100%;
  height: auto;
  max-height: 347px;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 340px;
  gap: 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0%;
  scroll-behavior: smooth;
  padding: 8px 0px 0px 0px;
  border-radius: 8px;
  justify-content: flex-start;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
  border: 1px solid #e0e2e7;
`;

const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #003049;
`;
